export default __webpack_public_path__ + "static/media/speed-banners.b332d8cd.webp";